export default {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT'
};
